module.exports = __webpack_public_path__ + "robotboy_1-786fb352fdf8bcf1be07fc59aa082bd9.png";